import React from "react";
import { ArrowRight, TrendingUp, Wallet, Users } from "lucide-react";
import { RevenueCalculator } from "./RevenueCalculator";

export const BusinessOpportunity = () => {
    return (
        <section
            id="oportunidade"
            data-testid="business-opportunity"
            className="relative py-20 md:py-32 overflow-hidden"
        >
            <div className="absolute inset-0 bg-brand-green" aria-hidden />
            <div
                aria-hidden
                className="absolute inset-0 opacity-[0.08] bg-hex-pattern pointer-events-none"
                style={{ backgroundImage: "url('/brand/pattern-3.png')" }}
            />
            <div
                aria-hidden
                className="absolute -bottom-40 -right-40 h-[500px] w-[500px] rounded-full bg-brand-orange/30 blur-3xl"
            />

            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid lg:grid-cols-12 gap-10 items-center">
                    <div className="lg:col-span-6 text-white">
                        <span className="inline-block text-xs font-bold uppercase tracking-[0.25em] text-brand-orange bg-white/10 backdrop-blur px-3 py-1.5 rounded-full">
                            Oportunidade de negócio
                        </span>
                        <h2 className="mt-5 font-display font-medium text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
                            Um negócio simples,
                            <br />
                            <span className="text-brand-orange">de alta margem.</span>
                        </h2>
                        <p className="mt-5 text-lg md:text-xl text-white/85 max-w-xl leading-relaxed">
                            Operação leve, baixo investimento, alta rentabilidade. Sem fruta
                            fresca a estragar, sem descascar, sem cortar. Apenas sabor — e lucro.
                        </p>

                        <div className="mt-8 grid sm:grid-cols-3 gap-3">
                            {[
                                {
                                    icon: Wallet,
                                    label: "Baixo investimento",
                                    value: "Acessível",
                                },
                                {
                                    icon: TrendingUp,
                                    label: "Margem média",
                                    value: "+70%",
                                },
                                {
                                    icon: Users,
                                    label: "Operação",
                                    value: "1 pessoa",
                                },
                            ].map((s) => (
                                <div
                                    key={s.label}
                                    className="rounded-2xl bg-white/10 backdrop-blur border border-white/15 p-4"
                                >
                                    <s.icon className="h-5 w-5 text-brand-orange" />
                                    <div className="mt-2 font-display font-medium text-2xl">
                                        {s.value}
                                    </div>
                                    <div className="text-xs text-white/80 mt-0.5">{s.label}</div>
                                </div>
                            ))}
                        </div>

                        <a
                            href="#contacto"
                            data-testid="cta-abrir-ponto"
                            className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand-orange hover:bg-brand-orange-dark text-white px-8 py-4 text-base font-semibold transition-all shadow-pop hover:translate-y-[-2px]"
                        >
                            Quero saber como abrir um ponto
                            <ArrowRight className="h-4 w-4" />
                        </a>

                        <div className="mt-8 inline-flex items-center gap-3 rounded-2xl bg-white/10 backdrop-blur border border-white/15 px-4 py-3">
                            <div className="h-2 w-2 rounded-full bg-brand-orange animate-pulse" />
                            <div className="text-sm text-white/90">
                                <span className="font-bold">Faz a tua simulação</span> →
                                descobre quanto podes faturar
                            </div>
                        </div>
                    </div>

                    <div className="lg:col-span-6" id="simulador">
                        <RevenueCalculator />
                    </div>
                </div>
            </div>
        </section>
    );
};
